import type { ReactNode } from 'react';

interface Props {
  label: string;
  htmlFor: string;
  error?: string | undefined;
  children: ReactNode;
}

export function FormField({ label, htmlFor, error, children }: Props) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={htmlFor} className="text-sm font-medium text-[var(--co-text)]">
        {label}
      </label>
      {children}
      {error ? (
        <span role="alert" className="text-xs text-[var(--co-error)]">
          {error}
        </span>
      ) : null}
    </div>
  );
}
